// extracted by mini-css-extract-plugin
export default {"wrapper":"ResultIdItem_wrapper__5v7hT","info":"ResultIdItem_info__8+vl8","info-winner":"ResultIdItem_info-winner__R4S-6"};